/**
 * Turns a grid of already-rendered strings into a CSV file and hands it to the browser.
 *
 * Kept apart from the table so the escaping can be read and tested on its own: the table decides
 * what the cells say, this decides how they survive being written to a file.
 */
export function toCsvContent(rows: string[][]): string {
  return rows.map((row) => row.map(escapeCsvValue).join(',')).join('\n')
}

/**
 * Spreadsheet software reads a cell opening with one of these as a formula rather than as text, so a
 * meeting named `=cmd|...` would run when someone opened the download. The apostrophe is what
 * spreadsheets take as "this is text", and it is not shown in the cell.
 */
const FORMULA_LEAD = /^[=+\-@\t\r]/

function escapeCsvValue(value: string): string {
  const text = FORMULA_LEAD.test(value) ? `'${value}` : value
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

export function downloadCsvFile(rows: string[][], filename: string, document: Document): void {
  const blob = new Blob([toCsvContent(rows)], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
